import type { LookGroupDTOType, LookGroupLookDTOType } from '../../schemas/styling';
import { updateAttributesOfCdnImage } from '@admin-panel/utils';

export const getLookGroupMotionId = (
  groupId: number,
  slot:
    | 'card'
    | 'workflow'
    | 'title'
    | 'product-image'
    | 'generated-image',
) => `look-group-${slot}-${groupId}`;

export const getPrimaryGeneratedImage = (group: LookGroupDTOType) =>
  group.primary_look?.image || group.primary_look?.generated_image_url || '';

export const getPrimarySourceImage = (group: LookGroupDTOType) =>
  group.primary_look?.source_image_url || '';

export const getPrimaryLookTitle = (group: LookGroupDTOType) =>
  group.primary_look?.look_name || group.primary_look?.look_hook || 'Primary look';

export const getPrimaryLookId = (group: LookGroupDTOType) =>
  group.primary_look?.id ?? group.primary_look_id ?? null;

export const getRenderableLooks = (group: LookGroupDTOType): Array<LookGroupLookDTOType> => {
  const looks = Array.isArray(group.looks) ? group.looks : [];

  if (!group.primary_look) {
    return looks;
  }

  const hasPrimaryLook = looks.some(look => look.id === group.primary_look?.id);

  if (hasPrimaryLook) {
    return looks;
  }

  return [group.primary_look, ...looks];
};

export const getImageUrl = (url?: string, width = 800) =>
  url
    ? updateAttributesOfCdnImage(url, {
        width,
        quality: 100,
      }) || url
    : '';

export const formatWorkflowLine = (group: LookGroupDTOType) =>
  [group.occasion_name, group.sub_occasion_name].filter(Boolean).join(' • ');
